<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#09c" type="pacman" [fullScreen]="true"></ngx-spinner>

<div *ngIf='loading == true' class="container text-white py-5">
    <div class="row">
        <div class="col-md-4">
            <img class="w-100" [src]="imgBaseUrl+seriesDetails.poster_path" >
        </div>
        <div class="col-md-8">
            <div class="seriesdetails">
                <h1 class="p-3">{{seriesDetails.name}}</h1>
                <p class="lead">{{seriesDetails.overview}}</p>
                <h4>Release Date : {{seriesDetails.last_air_date}}</h4>
            </div>
            <div class=" row">
                <div *ngFor="let series of top4" class=" cardbox  ">
                    <a [routerLink]="['/seriesdetails', series.id]">
                    <img [src]="imgBaseUrl+series.poster_path" class="card-img-top hightvalue">
                    <div class="card-body">
                      <h5 class="card-title back">{{series.name}}</h5>
                    </div>
                    </a>
                </div>
                
            </div>
            <div class="back margintop">
                <a  class="btn btn-outline-danger btn-lg active back" role="button" [routerLink]="['/series']">Back to Series</a>
            </div>
            
        </div>
    </div>
</div>
